$.ajaxSetup({
    dataType: 'JSON',
    headers: {
        'X-CSRF-TOKEN': $('[name="csrf-token"]').attr('content'),
    }, beforeSend: function () {
        $.showLoader();
    }
});
